import React, { useCallback } from "react";

import { useParams } from "react-router-dom";

import PersonRecordPane from "@app/component/preview/PersonRecordPane";

import styles from "./Common.module.scss";

interface Props {}

const PersonRecordPage: React.FC<Props> = () => {
  const { pid } = useParams<{ pid: string }>();
  const onHide = useCallback(() => {
    window.parent.postMessage("closeRecordPane", "*");
  }, []);

  return (
    <PersonRecordPane className={styles.container} onHide={onHide} personId={parseInt(pid, 10)} />
  );
};

export default PersonRecordPage;
